import React, { createContext, useContext, useEffect } from 'react';

/**
 * Tema del CRM.
 *
 * DESACTIVADO por decision de Marc (16-oct-2026): el CRM se queda siempre en
 * modo claro y no hay selector en la interfaz.
 *
 * Se mantiene el proveedor para no tocar el arbol de App.js, y se mantienen los
 * tokens --ink-* de index.css, que en claro renderizan igual que los hex
 * originales. Para reactivarlo en el futuro basta con restaurar la version
 * anterior de este fichero y volver a poner el boton en AppShell.jsx.
 */

const ThemeContext = createContext({ theme: 'light', setTheme: () => {}, toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    // Forzar claro siempre: se ignora tanto lo guardado como la preferencia del
    // sistema operativo, para que nadie se quede con el CRM en oscuro.
    const raiz = document.documentElement;
    raiz.classList.remove('dark');
    raiz.style.colorScheme = 'light';
    try {
      localStorage.removeItem('crm-tema');
    } catch (e) {
      /* localStorage puede fallar en modo privado */
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: 'light', setTheme: () => {}, toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

export default ThemeContext;
